import { render, staticRenderFns } from "./controlRecordTable.vue?vue&type=template&id=5220c28b&scoped=true&"
import script from "./controlRecordTable.vue?vue&type=script&lang=js&"
export * from "./controlRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./controlRecordTable.vue?vue&type=style&index=0&id=5220c28b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220c28b",
  null
  
)

export default component.exports